query ProductPurchasesList($page: Int, $rowsPerPage: Int, $filter: JSON) {
  productPurchases(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      platformId
      organizationId
      type
      startAt
      expiredAt
      refunded
      disputed
      buyerEmail
      organization {
        title
      }
      product {
        title
      }
      payment {
        userId
        amount {
          value
          currency
        }
      }
      subscriptionId
      subscription {
        id
        status
        provider
        renewSubscription
        autoRenewEditable
        billingCyclesComplete
      }
    }
  }
}
